function requireAll(r) { r.keys().forEach(r); }

requireAll( require.context( './ico/', true ) );
//requireAll( require.context( './gif/', true, /\.gif$/) );
requireAll( require.context( './fonts/', true ) );
requireAll( require.context( './png/', true, /\.gif|png$/) );
requireAll( require.context( './svg/', true, /\.svg$/) );

import $ from 'jquery';


import ScrollMagic from 'scrollmagic/scrollmagic/uncompressed/ScrollMagic';
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';
import TweenMax from 'gsap/src/uncompressed/TweenMax';
import TimelineMax from 'gsap/src/uncompressed/TimelineMax';
import Isotope from 'isotope-layout';
import Player from '@vimeo/player';
import objectFitImages from 'object-fit-images';
import ScrollReveal from 'scrollreveal';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';


window.jQuery = $;
window.$ = $;


$(function () {

	var scrollMagicController = new ScrollMagic.Controller();


	var PROJECT = {

		common: {

			init: function () {


				PROJECT.menu.init();

				PROJECT.dropdown.init();

				PROJECT.showreel.init();

				PROJECT.scrollreveal.init();

				PROJECT.nav.init();

				PROJECT.carousels.init();

				PROJECT.cta.init();

				PROJECT.gform.init();

				objectFitImages();

				window.scrollTo(0, 1);

				let vh = window.innerHeight * 0.01;
				// Then we set the value in the --vh custom property to the root of the document
				document.documentElement.style.setProperty('--vh', `${vh}px`);

				window.addEventListener('resize', () => {
					// We execute the same script as before
					let vh = window.innerHeight * 0.01;
					document.documentElement.style.setProperty('--vh', `${vh}px`);
				});

			}
		},

		nav: {

			init: function() {

				$( document ).on( 'click', '.jsHistoryBack', function( e ) {

					e.preventDefault();

					window.history.back();

				});

				$( document ).on( 'keyup', PROJECT.nav.postnav );

				// Select all links with hashes // Remove links that don't actually link to anything
				$( document ).on( 'click', 'a[href*="\\#"]:not([href="#"]):not([href="\\#back"])', function(e) {

					var hash = this.hash;

					if ( location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname ) {

						// Only prevent default if animation is actually gonna happen
						e.preventDefault();

						PROJECT.scroll.animate( hash );

						if ( $( this ).parent().hasClass( 'nav__item' ) ) {

							PROJECT.menu.close();

						}

					}

				});

			},

			postnav: function( e ) {

				if ( e.keyCode == 39 ) {

					if ( $( '.jsNextArrow a' ).length ) {

						$( '.jsNextArrow a' )[0].click();

					}
				}

				if ( e.keyCode == 37 ) {

					if ( $( '.jsPrevArrow a' ).length ) {

						$( '.jsPrevArrow a' )[0].click();

					}

				}
			}

		},

		scrollreveal: {

			sr: null,

			destroy: function() {
				
				if ( PROJECT.scrollreveal.sr ) {

					PROJECT.scrollreveal.sr.destroy();

				}

				PROJECT.scrollreveal.sr = null;

			},

			init: function() {


				PROJECT.scrollreveal.sr = new ScrollReveal({

					scale:	1,
					viewFactor: 0.25,
					duration: 800,
					distance: '60px'
				});

				// custom items to reveal

				PROJECT.scrollreveal.sr.reveal('.revealFromBottomHome', {

					duration: 300,
					container: '.doc'

				});

				PROJECT.scrollreveal.sr.reveal('.revealFromBottom', {

					duration: 500
				});


				PROJECT.scrollreveal.sr.reveal( '.revealListItem', {
					interval: 40
				});

				PROJECT.scrollreveal.sr.reveal('.revealFromLeft', {

					origin: 'left',

				});

				PROJECT.scrollreveal.sr.reveal('.revealFromRight', {

					origin: 'right',
					delay: 400,
					distance: '100px',

				});

				// default WP items to reveal

				PROJECT.scrollreveal.sr.reveal('.reveal .gallery .gallery-item');
				PROJECT.scrollreveal.sr.reveal('.reveal p');
				PROJECT.scrollreveal.sr.reveal('.reveal ul');
				PROJECT.scrollreveal.sr.reveal('.reveal ol');
				PROJECT.scrollreveal.sr.reveal('.reveal hr');
				PROJECT.scrollreveal.sr.reveal('.reveal blockquote');
				PROJECT.scrollreveal.sr.reveal('.reveal figure');
				PROJECT.scrollreveal.sr.reveal('.reveal h1');
				PROJECT.scrollreveal.sr.reveal('.reveal h2');
				PROJECT.scrollreveal.sr.reveal('.reveal h3');
				PROJECT.scrollreveal.sr.reveal('.reveal h4');
				PROJECT.scrollreveal.sr.reveal('.reveal h5');
				PROJECT.scrollreveal.sr.reveal('.reveal h6');
				PROJECT.scrollreveal.sr.reveal('.reveal .atom-button');
				PROJECT.scrollreveal.sr.reveal('.reveal form');
				PROJECT.scrollreveal.sr.reveal('.reveal label');
				PROJECT.scrollreveal.sr.reveal('.reveal input');
				PROJECT.scrollreveal.sr.reveal('.reveal select');
				PROJECT.scrollreveal.sr.reveal('.reveal textarea');
				PROJECT.scrollreveal.sr.reveal('.reveal button');
				PROJECT.scrollreveal.sr.reveal('.reveal div');



			}
		},

		dropdown: {

			init: function () {

				$( document ).on( 'click', '.listToggle', PROJECT.dropdown.toggle );

			},

			toggle: function ( e ) {

				e.preventDefault();

				$( event.target ).parents( '.listHolder' ).toggleClass( 'state--dropdown-shown' );

			}

		},

		menu: {

			init: function () {

				$( document ).on( 'click', '.navToggle', PROJECT.menu.toggle );

			},

			toggle: function ( e ) {

				e.preventDefault();

				$( 'html' ).toggleClass( 'state--nav-is-open' );

			},

			close: function () {

				$( 'html' ).removeClass( 'state--nav-is-open' );

			}

		},

		showreel: {

			state: 'closed',
			player: '',

			init: function() {

				$( document ).on( 'keyup', PROJECT.showreel.close );

				$( document ).on( 'click', '.jsToggleShowreel', PROJECT.showreel.toggle );

			},

			close: function( e ) {

				if ( e.keyCode == 27 ) {

					if ( PROJECT.showreel.state == 'open'  ) {

						PROJECT.showreel.state = 'closed';

						PROJECT.showreel.player.destroy();

						$( 'html').removeClass( 'state--showreel-open' );

					}

				}

			},

			toggle: function( e ) {

				e.preventDefault();

				var showreel_url = $( this ).data('showreel');

				if ( PROJECT.showreel.state == 'closed'  ) {

					$( 'html').addClass( 'state--showreel-open' );

					PROJECT.showreel.state = 'open';

					PROJECT.showreel.player = new Player( $('.jsShowreelVideo'), {
						url: showreel_url,
						autoplay: 1
					});

					$('.bgVideos').each( function() {

						var player = $(this).find('video');

						player[0].pause();

					});

				} else {

					$('.bgVideos').each( function() {

						var player = $(this).find('video');

						player[0].play();

					});

					PROJECT.showreel.state = 'closed';
					PROJECT.showreel.player.destroy();

					$( 'html').removeClass( 'state--showreel-open' );

				}

			}

		},

		cta: {

			init: function() {

				$( document ).on( 'click', '.floatingCtaToggle', PROJECT.cta.toggle );

			},

			toggle: function( e ) {

				e.preventDefault();

				$( 'html' ).toggleClass( 'state--view-cta-float-open' );

			}

		},

		gform: {

			init: function() {

				$( document ).on( 'gform_post_render', PROJECT.gform.hideLoader );
				$( document ).on( 'click.loader', '.gform_button', PROJECT.gform.showLoader );

				$( document ).on( 'click.loader', '.gform_next_button, gform_previous_button', PROJECT.gform.showLoader );
				$( document ).on( 'gform_page_loaded', PROJECT.gform.hideLoader );


				$( document ).on( 'gform_confirmation_loaded', PROJECT.gform.showConfirmation );
				$( document ).on( 'click.loader', '.gformCloseConfirmation', PROJECT.gform.hideConfirmation );


				$( document ).on( 'focus', 'input, textarea, select', function() {
					$( this ).parents( '.gfield' ).addClass( 'state--has-focus' );
				});

				$( document ).on( 'blur', 'input, textarea, select', function() {

					if( !$(this).val() ) {
						$( this ).parents( '.gfield' ).removeClass( 'state--has-focus' );
					}
				});

				$( '.gfield label[for]' ).each( function() {

					var type = $( 'input#' + $( this ).attr('for') ).attr('type');
					if (type) {
						$( this ).closest('.gfield').addClass( 'gfield--type-' + type.toLowerCase() );
					}

					var type = $( 'textarea#' + $( this ).attr('for') ).prop("tagName");
					if (type) {
						$( this ).closest('.gfield').addClass( 'gfield--type-' + type.toLowerCase() );
					}

				});

			},

			showLoader: function( e ) {

				if ( $( e.target ).parents( '.gformContainer' ).find( 'input:invalid' ).length == 0 ) {

					$( e.target ).parents( '.gformContainer' ).find( '.gformLoader' ).fadeIn( 300 ).css( 'display', 'flex' );
				}

			},

			hideLoader: function( e ) {


				$( '.gformLoader' ).fadeOut( 300 );

				$( '.gfield label[for]' ).each( function() {

					var type = $( 'input#' + $( this ).attr('for') ).attr('type');
					if (type) {
						$( this ).closest('.gfield').addClass( 'gfield--type-' + type.toLowerCase() );
					}

					var type = $( 'textarea#' + $( this ).attr('for') ).prop("tagName");
					if (type) {
						$( this ).closest('.gfield').addClass( 'gfield--type-' + type.toLowerCase() );
					}

					var type = $( 'select#' + $( this ).attr('for') ).prop("tagName");
					if (type) {
						$( this ).closest('.gfield').addClass( 'gfield--type-' + type.toLowerCase() );
					}

				});

			},

			showConfirmation: function() {

				$( '.gformConfirmation' ).fadeIn( 300 ).css( 'display', 'flex' );

			},

			hideConfirmation: function() {

				$( '.gformConfirmation' ).fadeOut( 300 );

			}
		},

		page: {

			home: function() {

				PROJECT.scroll.init();

				$('.bgVideos').each( function() {

					let finishCalled = true;
					var videos = $(this).data( 'videos' );
					var counter = 0;
					var holder = $(this);
					var player = $(this).find('video');

					if ( videos.length > 0 ) {

						holder.addClass( 'state--video-loaded' );

						// player.on( 'loaded', function() {



						// });

						if ( videos.length > 1 ) {

							player.on( 'play', function() {

								var upcounter = counter >= ( videos.length - 1) ? 0 : counter + 1;

								// if( videos[upcounter].thumb ) {

								// 	holder.css( 'background-image', 'url(' + videos[upcounter].thumb + ' )' );
								// 	finishCalled = false;
								// }

							});

							player.on( 'ended',  function (event) {

								player[0].src = null;

								//holder.removeClass( 'state--video-loaded' );

								if ( !finishCalled ) {

									finishCalled = true;
									counter = counter >= ( videos.length - 1) ? 0 : counter + 1;

									player[0].src = videos[counter].url;
									player[0].load();

									player.on( 'loadeddata', function() {

										//holder.addClass( 'state--video-loaded' );
										finishCalled = false;

									});
								}
							});
						}
					}
				});

				if ( $( '.jsScrollIndicator' ).length ) {

					setInterval( function() {

						var left = $( '.jsScrollIndicator' ).offset().left;

						if ( left <= 100 ) {
							$( 'html' ).addClass( 'state--scroll-indcator-is-sticky' );

						} else {
							$( 'html' ).removeClass( 'state--scroll-indcator-is-sticky' );
						}

					}, 100 );

				}

				// Cache the highest
				var highestBox = 0;

				// Select and loop the elements you want to equalise
				$('.equalHeight', this).each(function() {

					// If this box is higher than the cached highest then store it
					if( $(this).height() > highestBox ) {

						highestBox = $(this).height();

					}

				});

				// Set the height of all those children to whichever was highest

				if ( highestBox > 0 ) {

					$('.equalHeight').height(highestBox);

				}

				$( document ).on( 'click', '.section-home a', function() {

					var hash  = $(this).parents( '.section-home' ).attr('id');

					if ( hash.length && history.pushState ) {

						history.pushState(null, null, '#' + hash );

					}

				});
			},

			projects: function() {

				PROJECT.filter.init();

			},

			clients: function() {

				PROJECT.filter.init();

			},

			process: function() {

				PROJECT.process.init();
			},

			history: function() {

				PROJECT.scroll.init();

			}

		},

		scroll: {

			scrollLeft: 0,
			prevScrollLeft: 0,

			init: function() {

				var scene = '';

				if ( $( '.jsHorizontalScroll' ).length ) {

					// $( window ).on( 'wheel', function( e ) {

					// 	$('.section-home').each(function(){

					// 		var hash = $(this).attr('id');

					// 		var offset = window.outerWidth / 2;

					// 		if ( hash.length && history.pushState ) {

					// 			if ( $(this).offset().left < window.pageXOffset + offset && $(this).offset().left + $(this).width() > window.pageXOffset + offset ) {
					// 				// Progressive Enhancement
					// 				history.pushState(null, null, '#' + hash );
					// 			}
					// 		}

					// 	});

					// } );


					if ( window.pageXOffset > 8 ) {

						$( 'html' ).addClass( 'state-bg-header' );

					} else {

						$( 'html' ).removeClass( 'state-bg-header' );
					}


					if ( $( '.mc4wp-form-error' ).length || $( '.mc4wp-form-success' ).length ) {

						if ( $( '.page--home' ).length ) {

							var hash = '#contact';

						} else {

							var hash = '#footer';
						}

						PROJECT.scroll.animate( hash );

					} else if ( window.location.hash ) {

						var hash = window.location.hash;

						PROJECT.scroll.animate( hash );

					}

					$( '.jsHorizontalScroll' ).on( 'mousewheel', function( e, t ) {

						this.scrollLeft -= 2 * t;

						e.preventDefault();

					} );
		
				}
			},

			animate: function( hash ) {

				if ( hash != '' ) {

					// Figure out element to scroll to
					var $target = $( hash );

					// Does a scroll target exist?
					if ( $target.length ) {

						var elementWidth = $target.outerWidth() / 2;

						$target.parent().prevAll().each( function() {

							var width = $(this).outerWidth();

							elementWidth += width;

						});

						var $parent = $target.closest( '.jsHorizontalScrollItem' );

						if ( !$parent.length ) {

							$parent = $target;

						}

						$parent.prevAll().each( function() {

							var width = $(this).outerWidth();

							elementWidth += width;

						});

						//$( '.doc' ).animate({ scrollLeft : elementWidth - ( window.innerWidth / 2 ) }, 100 );
						$( '.doc' ).scrollLeft( elementWidth - ( window.innerWidth / 2 ) );

					}
				}
			}
		},

		filter: {

			grid: {},
			filters: {},
			hashFilter: '',

			init: function() {


				PROJECT.filter.grid = new Isotope( '[data-js="isotope"]', {

					itemSelector: '.listItem',

					percentPosition: true,

					masonry: {

						columnWidth: '.listItem',

					}

				});

				$(window).on( 'hashchange', PROJECT.filter.onHashchange );

				PROJECT.filter.onHashchange();

				// store filter for each group

				$( document ).on( 'click', '[data-filter]', function( e ) {

					e.preventDefault();

					// get group key
					var filterGroup = $( this ).parents( '[data-filter-group]' ).data( 'filter-group' );

					// set filter for group
					PROJECT.filter.filters[ filterGroup ] = $( this ).data( 'filter' );

					// combine filters
					var filterValue = PROJECT.filter.concatValues( PROJECT.filter.filters );

					location.hash = 'filter=' + encodeURIComponent( filterValue );

				} );

				$( document ).on( 'click', '.jsFilterClear', function( e ) {

					e.preventDefault();

					location.hash = 'filter=*';

				});

			},

			onHashchange: function() {

				PROJECT.filter.hashFilter = PROJECT.filter.getHashFilter();

				if ( !PROJECT.filter.hashFilter && PROJECT.filter.isIsotopeInit ) {

					return;

				}

				if ( PROJECT.filter.hashFilter && PROJECT.filter.hashFilter != '*' ) {

					$( '.jsFilterClear' ).addClass( 'state-is-shown' );



				} else {

					$( '.jsFilterClear' ).removeClass( 'state-is-shown' );
				}

				// console.log(  PROJECT.filter.hashFilter );

				// set selected class on button
				if ( PROJECT.filter.hashFilter ) {

					// doesn't do shit.... 
					// PROJECT.scrollreveal.sr.clean(  '.revealListItem' );

					PROJECT.scrollreveal.destroy();
					
					// clean up scrollreveal on list items, scroll reveal won't trigger after filtering
					var $items = $( '.revealListItem' );

					$items.removeAttr( 'style' ).removeClass( 'revealListItem' );					
					
					// PROJECT.scrollreveal.sr.destroy();

					// PROJECT.scrollreveal.destroy();

					var active_filters = PROJECT.filter.hashFilter.split( '.' );

					$( '.jsFilterCount' ).text( active_filters.length - 1 );

					$( '.listHolder' ).removeClass( 'state--dropdown-shown' );

					// change is-checked class on buttons
					$( '[data-filter-group]' ).each( function( i, buttonGroup ) {

						var $buttonGroup = $( buttonGroup );

						for (i = 0; i < active_filters.length; i++ ) {

							if ( $buttonGroup.find( '[data-filter=".' + active_filters[i] + '"]').length ) {

								$buttonGroup.find( '[data-filter].state--is-active' ).removeClass( 'state--is-active' );

								$buttonGroup.find( '[data-filter=".' + active_filters[i] + '"]').addClass( 'state--is-active' );

								$buttonGroup.parents( '.view-filter' ).addClass( 'has-filter' );

							} else if ( active_filters[i] == '*' ) {

								$buttonGroup.find( '[data-filter].state--is-active' ).removeClass( 'state--is-active' );

								$buttonGroup.find( '[data-filter="' + active_filters[i] + '"]').addClass( 'state--is-active' );

								$buttonGroup.parents( '.view-filter' ).removeClass( 'has-filter' );

							}

						}

					});


					if ( ! PROJECT.filter.isIsotopeInit ) {

						// change is-checked class on buttons
						$( '[data-filter-group]' ).each( function( i, buttonGroup ) {

							var $buttonGroup = $( buttonGroup );

							// get group key
							var filterGroup = $buttonGroup.data( 'filter-group' );

							$buttonGroup.find( '[data-filter].state--is-active' ).each( function() {

								// set filter for group
								PROJECT.filter.filters[ filterGroup ] = $( this ).data( 'filter' );

							} );

						});

					}

					if ( PROJECT.filter.hashFilter == '*' ) {

						// change is-checked class on buttons
						$( '[data-filter-group]' ).each( function( i, buttonGroup ) {

							// get group key
							var filterGroup = $( buttonGroup ).data( 'filter-group' );

							PROJECT.filter.filters[ filterGroup ] = '';

						});

					}


					PROJECT.filter.isIsotopeInit = true;

					// filter isotope
					PROJECT.filter.grid.arrange({

						filter: PROJECT.filter.hashFilter

					});

					PROJECT.filter.grid.on( 'layoutComplete', function(e) {

						
						// $items.addClass( 'revealListItem' );

						// PROJECT.scrollreveal.sr.sync();

						// PROJECT.scrollreveal.sr.clean(  '.revealListItem' );

						$items.removeAttr( 'style' );

						$( window ).trigger( 'resize' );
						

					} );
				}

				// flatten object by concatting values

			},

			concatValues: function( obj ) {

				var value = '';

				for ( var prop in obj ) {

					if ( obj[prop] != '*' ) {

						value += obj[ prop ];

					}

				}

				if ( value == '' ) {

					value = '*';
				}

				return value;

			},

			getHashFilter:	function() {

				// get filter=filterName
				var matches = location.hash.match( /filter=([^&]+)/i );

				var hashFilter = matches && matches[1];

				return hashFilter && decodeURIComponent( hashFilter );

			}


		},

		process: {

			init: function() {

				$( '.processItem' ).each( function() {

					var elem = this;
					var player = $(this).find('video');

					player.on( 'loadeddata', function() {

						$(elem).find( '.bgVideos' ).addClass( 'state--video-loaded' );

					});
					player[0].pause();


					new ScrollMagic.Scene({
						triggerElement: elem,
						triggerHook: .5,
						duration: '100%'
					})
					.on( 'enter', function() {

						player[0].play();
					})
					.on( 'leave', function() {
						player[0].pause();
					})
					.addTo( scrollMagicController );

				});
			}
		},

		carousels: {

			init: function() {

				PROJECT.carousels.testimonials();

			},

			testimonials: function() {

				var carousels = document.querySelectorAll( '.jsTestimonials' );

				if ( typeof carousels === 'object' && carousels.length > 0 ) {

					carousels.forEach((carousel, index) => {
						
						const carouselContainer = carousel.querySelector( '.jsCarousel' );
						const pager = carousel.querySelector( '.jsCarouselPagination' );
						const prev = carousel.querySelector( '.jsCarouselPrev' );
						const next = carousel.querySelector( '.jsCarouselNext' );

						const swiper = new Swiper( carouselContainer, {
							
							modules: [Pagination,Navigation],

							slidesPerView: 1,

							spaceBetween: 0,

							navigation: {
								nextEl: next,
								prevEl: prev,
							},

							pagination: {

								el: pager,
								type: 'fraction', 
								clickable: false,

							},
							
							
						});

					});

				}

			},

		},

	};

	var UTIL = {

		exec: function (controller, action) {

			var ns = PROJECT;
			action = (action === undefined) ? 'init' : action;

			if (controller !== '' && ns[controller] && typeof ns[controller][action] === 'function') {

				ns[controller][action]();

			}

		},

		init: function () {

			var body = document.body,
				controller = body.getAttribute('data-controller'),
				action = body.getAttribute('data-action');

			UTIL.exec('common');
			UTIL.exec(controller);
			UTIL.exec(controller, action);

		}

	};

	//$.PROJECT = PROJECT; // Make global available

	$(window).ready(UTIL.init);

});

var toFix  = ['wheel', 'mousewheel', 'DOMMouseScroll', 'MozMousePixelScroll'],
	toBind = ( 'onwheel' in document || document.documentMode >= 9 ) ?
			['wheel'] : ['mousewheel', 'DomMouseScroll', 'MozMousePixelScroll'],
	slice  = Array.prototype.slice,
	nullLowestDeltaTimeout, lowestDelta;

if ( $.event.fixHooks ) {
	for ( var i = toFix.length; i; ) {
		$.event.fixHooks[ toFix[--i] ] = $.event.mouseHooks;
	}
	}

var special = $.event.special.mousewheel = {
	version: '3.1.12',

	setup: function() {
		if ( this.addEventListener ) {
			for ( var i = toBind.length; i; ) {
				this.addEventListener( toBind[--i], handler, false );
			}
		} else {
			this.onmousewheel = handler;
		}
		// Store the line height and page height for this particular element
		$.data(this, 'mousewheel-line-height', special.getLineHeight(this));
		$.data(this, 'mousewheel-page-height', special.getPageHeight(this));
	},

	teardown: function() {
		if ( this.removeEventListener ) {
			for ( var i = toBind.length; i; ) {
				this.removeEventListener( toBind[--i], handler, false );
			}
		} else {
			this.onmousewheel = null;
		}
		// Clean up the data we added to the element
		$.removeData(this, 'mousewheel-line-height');
		$.removeData(this, 'mousewheel-page-height');
	},

	getLineHeight: function(elem) {
		var $elem = $(elem),
			$parent = $elem['offsetParent' in $.fn ? 'offsetParent' : 'parent']();
		if (!$parent.length) {
			$parent = $('body');
		}
		return parseInt($parent.css('fontSize'), 10) || parseInt($elem.css('fontSize'), 10) || 16;
	},

	getPageHeight: function(elem) {
		return $(elem).height();
	},

	settings: {
		adjustOldDeltas: true, // see shouldAdjustOldDeltas() below
		normalizeOffset: true  // calls getBoundingClientRect for each event
	}
};

$.fn.extend({
	mousewheel: function(fn) {
		return fn ? this.bind('mousewheel', fn) : this.trigger('mousewheel');
	},

	unmousewheel: function(fn) {
		return this.unbind('mousewheel', fn);
	}
});


function handler(event) {
	var orgEvent   = event || window.event,
		args       = slice.call(arguments, 1),
		delta      = 0,
		deltaX     = 0,
		deltaY     = 0,
		absDelta   = 0,
		offsetX    = 0,
		offsetY    = 0;
	event = $.event.fix(orgEvent);
	event.type = 'mousewheel';

	// Old school scrollwheel delta
	if ( 'detail'      in orgEvent ) { deltaY = orgEvent.detail * -1;      }
	if ( 'wheelDelta'  in orgEvent ) { deltaY = orgEvent.wheelDelta;       }
	if ( 'wheelDeltaY' in orgEvent ) { deltaY = orgEvent.wheelDeltaY;      }
	if ( 'wheelDeltaX' in orgEvent ) { deltaX = orgEvent.wheelDeltaX * -1; }

	// Firefox < 17 horizontal scrolling related to DOMMouseScroll event
	if ( 'axis' in orgEvent && orgEvent.axis === orgEvent.HORIZONTAL_AXIS ) {
		deltaX = deltaY * -1;
		deltaY = 0;
	}

	// Set delta to be deltaY or deltaX if deltaY is 0 for backwards compatabilitiy
	delta = deltaY === 0 ? deltaX : deltaY;

	// New school wheel delta (wheel event)
	if ( 'deltaY' in orgEvent ) {
		deltaY = orgEvent.deltaY * -1;
		delta  = deltaY;
	}
	if ( 'deltaX' in orgEvent ) {
		deltaX = orgEvent.deltaX;
		if ( deltaY === 0 ) { delta  = deltaX * -1; }
	}

	// No change actually happened, no reason to go any further
	if ( deltaY === 0 && deltaX === 0 ) { return; }

	// Need to convert lines and pages to pixels if we aren't already in pixels
	// There are three delta modes:
	//   * deltaMode 0 is by pixels, nothing to do
	//   * deltaMode 1 is by lines
	//   * deltaMode 2 is by pages
	if ( orgEvent.deltaMode === 1 ) {
		var lineHeight = $.data(this, 'mousewheel-line-height');
		delta  *= lineHeight;
		deltaY *= lineHeight;
		deltaX *= lineHeight;
	} else if ( orgEvent.deltaMode === 2 ) {
		var pageHeight = $.data(this, 'mousewheel-page-height');
		delta  *= pageHeight;
		deltaY *= pageHeight;
		deltaX *= pageHeight;
	}

	// Store lowest absolute delta to normalize the delta values
	absDelta = Math.max( Math.abs(deltaY), Math.abs(deltaX) );

	if ( !lowestDelta || absDelta < lowestDelta ) {
		lowestDelta = absDelta;

		// Adjust older deltas if necessary
		if ( shouldAdjustOldDeltas(orgEvent, absDelta) ) {
			lowestDelta /= 40;
		}
	}

	// Adjust older deltas if necessary
	if ( shouldAdjustOldDeltas(orgEvent, absDelta) ) {
		// Divide all the things by 40!
		delta  /= 40;
		deltaX /= 40;
		deltaY /= 40;
	}

	// Get a whole, normalized value for the deltas
	delta  = Math[ delta  >= 1 ? 'floor' : 'ceil' ](delta  / lowestDelta);
	deltaX = Math[ deltaX >= 1 ? 'floor' : 'ceil' ](deltaX / lowestDelta);
	deltaY = Math[ deltaY >= 1 ? 'floor' : 'ceil' ](deltaY / lowestDelta);

	// Normalise offsetX and offsetY properties
	if ( special.settings.normalizeOffset && this.getBoundingClientRect ) {
		var boundingRect = this.getBoundingClientRect();
		offsetX = event.clientX - boundingRect.left;
		offsetY = event.clientY - boundingRect.top;
	}

	// Add information to the event object
	event.deltaX = deltaX;
	event.deltaY = deltaY;
	event.deltaFactor = lowestDelta;
	event.offsetX = offsetX;
	event.offsetY = offsetY;
	// Go ahead and set deltaMode to 0 since we converted to pixels
	// Although this is a little odd since we overwrite the deltaX/Y
	// properties with normalized deltas.
	event.deltaMode = 0;

	// Add event and delta to the front of the arguments
	args.unshift(event, delta, deltaX, deltaY);

	// Clearout lowestDelta after sometime to better
	// handle multiple device types that give different
	// a different lowestDelta
	// Ex: trackpad = 3 and mouse wheel = 120
	if (nullLowestDeltaTimeout) { clearTimeout(nullLowestDeltaTimeout); }

	nullLowestDeltaTimeout = setTimeout(nullLowestDelta, 200);

	return ($.event.dispatch || $.event.handle).apply(this, args);
}

function nullLowestDelta() {
	lowestDelta = null;
}

function shouldAdjustOldDeltas(orgEvent, absDelta) {
	// If this is an older event and the delta is divisable by 120,
	// then we are assuming that the browser is treating this as an
	// older mouse wheel event and that we should divide the deltas
	// by 40 to try and get a more usable deltaFactor.
	// Side note, this actually impacts the reported scroll distance
	// in older browsers and can cause scrolling to be slower than native.
	// Turn this off by setting $.event.special.mousewheel.settings.adjustOldDeltas to false.
	return special.settings.adjustOldDeltas && orgEvent.type === 'mousewheel' && absDelta % 120 === 0;
}

function isTouchDevice() {
	return (('ontouchstart' in window)
	|| (navigator.MaxTouchPoints > 0)
	|| (navigator.msMaxTouchPoints > 0));
}
